import { observable, action} from 'mobx';
import Cell from './emptyCell';
import Parent from './parent';
import Transport from './transport'
import {shipment, finance, time} from '../index';
import settings from '../cultureSettings.json'


export default class OutputBunker extends Parent{
    @observable activeTransport;

    constructor(num,bunkerType, name='', culture = "None", amount=0, moistureLevel = 0 , wasteLevel =0,scenario =[],status=''){
        super(num, culture, scenario, amount, moistureLevel, wasteLevel, status, name);
        this.bunkerType = bunkerType;
        this.activeTransport = new Cell();
        this.type = 'output'
    }

    findTransport(culture){
       return shipment.outputTransport.findIndex((item)=>(item.type===this.bunkerType && item.culture === culture))
    }

    @action filling(culture,delta,waste,moisture){
        this.active = true;
        super.filling(culture,delta,waste,moisture)
    }

    @action shippingFrom(){
        if(!this.active && this.amount <=0 && this.culture!=='None')this.setUnit();
        if(this.activeTransport.culture !== this.culture){
            let availableTrain = this.findTransport(this.culture);
            if(availableTrain !== -1){
                if(shipment.outputTransport[availableTrain].offer) this.offer = shipment.outputTransport[availableTrain].offer;
                shipment.outputTransport[availableTrain].quantity--;
                if(!shipment.outputTransport[availableTrain].quantity){shipment.removeOutputTransport(availableTrain)}
                this.activeTransport = new Transport(this.culture,Math.floor(((this.bunkerType ==='truck' ? 20 : 60) * settings[this.culture].volume)*10)/10,0,this.moistureLevel,this.wasteLevel);
            }
        }
        if(!this.activeTransport.disabled && this.amount > 0){
            let transport = this.activeTransport;
            transport.filling(this.amount);
            if(transport.totalCapacity <= transport.amount){
                let availableTrain = this.findTransport(this.culture);
                if(availableTrain !== -1){
                    if(shipment.outputTransport[availableTrain].offer) this.offer = shipment.outputTransport[availableTrain].offer;
                    shipment.outputTransport[availableTrain].quantity--;
                    if(!shipment.outputTransport[availableTrain].quantity){shipment.removeOutputTransport(availableTrain)}
                    this.activeTransport = new Transport(this.culture,Math.floor(((this.bunkerType ==='truck' ? 20 : 60) * settings[this.culture].volume)*10)/10,0,this.moistureLevel,this.wasteLevel);
                }else{
                    this.activeTransport = new Cell();
                    this.offer = null;
                }
            }
            finance.incParams('output',transport.culture,this.amount);
            if(this.offer){this.offer.decRem(this.amount)}
            this.amount = 0;
        }
        this.active = false;
    }

    @action getOutputSpeed(){
        let speed = 1.5*time.tickCoef;
        if(this.activeTransport.disabled){
            let availableTrain = this.findTransport(this.culture);
            if(availableTrain !== -1){
                shipment.outputTransport[availableTrain].quantity--;
                if(!shipment.outputTransport[availableTrain].quantity){shipment.removeOutputTransport(availableTrain)}
                this.activeTransport = new Transport(this.culture,Math.floor(((this.bunkerType ==='truck' ? 20 : 60) * settings[this.culture].volume)*10)/10,0,this.moistureLevel,this.wasteLevel);
            }
            return speed;
        }else{
            if(this.activeTransport.totalCapacity - this.activeTransport.amount - speed <=0)return this.activeTransport.totalCapacity - this.activeTransport.amount;
            return speed;
        }
    }


}



// WEBPACK FOOTER //
// ./src/shared/stores/objects/outputBunker.js